import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Login from '../pages/Login';
import { apiService } from '../services/api';
import { saveUserToLocalStorage } from '../utils/userUtils';

const AuthGuard = ({ children }) => {
  const hasToken = Boolean(localStorage.getItem('token'));
  const [isAuthenticated, setIsAuthenticated] = useState(hasToken);
  const [loading, setLoading] = useState(!hasToken);
  const navigate = useNavigate();

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    const currentToken = localStorage.getItem('token');
    if (!currentToken) {
      setLoading(false);
      setIsAuthenticated(false);
      return;
    }

    if (currentToken === 'demo-token') {
      saveUserToLocalStorage({
        username: 'demo_user',
        role: 'admin',
        is_superuser: true,
      }, { token: currentToken });
      setIsAuthenticated(true);
      setLoading(false);
      return;
    }

    try {
      const response = await apiService.getCurrentUser();
      if (response.status === 200 && response.data) {
        saveUserToLocalStorage(response.data, { token: currentToken });
        setIsAuthenticated(true);
      } else {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        setIsAuthenticated(false);
      }
    } catch (error) {
      if (error.response?.status === 401) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        setIsAuthenticated(false);
      } else {
        setIsAuthenticated(true);
      }
    } finally {
      setLoading(false);
    }
  };

  const handleLoginSuccess = () => {
    localStorage.removeItem('skip_demo_login');
    setIsAuthenticated(true);
    setLoading(false);
    // Перенаправляем сразу в раздел прокси
    navigate('/proxies');
  };

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        fontSize: '18px',
        color: '#1890ff'
      }}>
        Проверка авторизации...
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Login onLoginSuccess={handleLoginSuccess} />;
  }

  return children;
};

export default AuthGuard;
